import _ from 'lodash';
import moment from 'moment';

import { ENTITIES_LABEL, VIRTUAL_ENTITIES_LABEL } from '../constants/EntitiesModalConstants';
import { STANDALONE_DASHBOARD_TYPES } from '../constants/StandaloneLayoutConstants';
import { xml2json } from '../form-designer/utils/runtime.utils';

export const modifyEntities = (entities = []) =>
  entities.map((entity) => ({
    id: entity.SSE_ID,
    name: entity.SSE_ENTITY_NAME,
    viewName: entity.SSE_ENTITY_VIEW_NAME,
    version: entity.SSE_VERSION,
    releaseType: entity.SSE_RELEASE_TYPE,
    modifiedDate: (entity.SSE_MODIFIED_DATE && moment.utc(entity.SSE_MODIFIED_DATE).local()) || '',
    isParentEntity: entity.SSE_IS_PARENT,
  }));

export const modifyEntityCatalogItems = ({ entities = [] }) =>
  entities.map((item) => ({
    id: item.id,
    translatedEntityName: item.Label,
    label: `${item.Label} (${item.id})`,
    viewName: item.ViewName,
    isVirtual: item.IsVirtualEntity,
  }));

export const modifyCreateSavedSearchEntities = ({ listItems = [], translateString }) => {
  const realEntities = listItems.filter((entity) => !entity.isVirtual);
  const sortedRealEntities = _.sortBy(realEntities, (entity) => entity.label.toLowerCase());

  const virtualEntities = listItems.filter((entity) => entity.isVirtual);
  const sortedVirtualEntities = _.sortBy(virtualEntities, (entity) => entity.label.toLowerCase());

  const entitiesList = [];

  sortedRealEntities.length &&
    entitiesList.push({
      id: 'Entities',
      label: translateString(ENTITIES_LABEL),
      children: sortedRealEntities,
    });

  sortedVirtualEntities.length &&
    entitiesList.push({
      id: 'VirtualEntities',
      label: translateString(VIRTUAL_ENTITIES_LABEL),
      children: sortedVirtualEntities,
    });

  return entitiesList;
};

export const getCreateFormTranslatedEntities = ({ listItems = [], translateString }) => {
  const translatedEntities = listItems.map((entity) => ({
    label: `${translateString(entity.name)} (${entity.viewName})`,
    value: entity.name,
    id: entity.id,
  }));

  return _.sortBy(translatedEntities, (entity) => entity.label);
};

export const getImportTypeLabel = (dashboardType) => {
  switch (dashboardType) {
    case STANDALONE_DASHBOARD_TYPES.ENTITIES:
      return 'Entity';
    case STANDALONE_DASHBOARD_TYPES.FORMS:
      return 'Form';
    case STANDALONE_DASHBOARD_TYPES.REPORT_MODELS:
      return 'Report Model';
    case STANDALONE_DASHBOARD_TYPES.REPORTS:
      return 'Report';
    default:
      return 'File';
  }
};

export const validateEntityXml = ({ xml, errorMessage }) => {
  const parsedJson = xml2json(xml);
  const { entityDesign, ssEntityInfo } = parsedJson?.entityPackage ?? {};

  if (!entityDesign || !ssEntityInfo) {
    throw new Error(errorMessage);
  }
};
